var DEVICE_TYPES = /*#__PURE__*/function (DEVICE_TYPES) {
  DEVICE_TYPES["MOBILE"] = "mobile";
  DEVICE_TYPES["DESKTOP"] = "desktop";
  DEVICE_TYPES["TABLET"] = "tablet";
  return DEVICE_TYPES;
}(DEVICE_TYPES || {});

export { DEVICE_TYPES as D };
//# sourceMappingURL=deviceTypes-wW4MAd2m-wW4MAd2m.js.map
